//issue 257 services
import moment from 'moment'
//issue 257 services
export default {
    "title": "Shipment",
    "entityName": "shipment",
    "pagination": {
        "itemsPerPage": 5,
        "page": 1,
        "sortBy": "id",
        "descending": true
    },
    "fields": [

        {
            full:true,
            "value": "protocol",
            "text": "Protocol",
            "title": "name",
            "type": "autocomplete",
            "table": {
                "sortable": true,
                "filter": true
            },
            render:  item => item.protocol.name
        },
        {
            full:true,
            "value": "owner.surname",
            "text": "Insert By",
            "title": "owner.surname",
            "type": "text",
            "table": {
                "sortable": true,
                "filter": true
            },
            render:  item => item.owner.surname,
            tooltip: (item) => { return item.insert_at }
        },
        {
            full:true,
            "value": "pickup_date",
            "text": "Pickup Date",
            "type": "date",
            //issue 148
            "filtertofrom": true,
            //issue 148
            "table": {
                "sortable": true,
                "filter": true
            },
            render:  item => { 
                //issue 257 services
                //return item.pickup_date + (item.pickup_hour ? "<br> ( " + item.pickup_hour.start + ' - ' + item.pickup_hour.end +' )' : '')
                return moment(item.pickup_date).format('DD-MMM-YYYY') + (item.pickup_hour ? "<br> ( " + item.pickup_hour.start + ' - ' + item.pickup_hour.end +' )' : '')
                //issue 257 services
            },
        },
        {
            full:true,
            "value": "pickup_id",
            "text": "Pickup point",
            "title": "name",
            "type": "autocomplete",
            "table": {
                "sortable": true,
                "filter": true
            },
            render:  item => { 
                return (item.pickup.site_id ? 'Site ' : 'Lab ') + item.pickup.city
            },
            tooltip: item => {
                return item.pickup.name
            }
        },
        {
            full:true,
            "value": "delivery_id",
            "text": "Delivery point",
            "title": "name",
            "type": "autocomplete",
            "table": {
                "sortable": true,
                "filter": true
            },
            // render: item => `${item.site.factor_label}`,
            render:  item => {
                return (item.delivery.site_id ? 'Site ' : 'Lab ') + item.delivery.city
            },
            tooltip: item => {
                return item.delivery.name
            }
        },
    


        {
            small:true,
            "value": "carrier",
            "text": "Carrier",
            // "type": "list",
            // list: ['EMN Logistic', 'DHL', 'FEDEX', 'SPECIAL SERVICES', 'TNT', 'UPS'],

            "readonly":true,
            "table": {
                "sortable": true,
                "filter": true
            },
            "validators": [
                "required"
            ],
            filter: (item, search) => [{ 'carrier': `%${search}%`},{'num':`${search}`},{'tracking_number':`${search}`}],
            click: item => {
                var value = null
                if(item.carrier == 'EMN Logistic' || item.carrier == 'SPECIAL SERVICES') {
                    if(item.num) {
                        value = item.num
                    }
                } else {
                    if(item.tracking_number) {
                        value = item.tracking_number
                    }
                }

                if(value) {
                    navigator.clipboard.writeText(value);
                }
            },
            render:  item => {
                if(!item.carrier) {
                    return ''
                }

                var str = item.carrier;

                if(item.carrier == 'EMN Logistic' || item.carrier == 'SPECIAL SERVICES') {

                    if(item.num) {
                        str +=  ' (' + item.num + ')'
                    }
                } else {
                    if(item.tracking_number) {
                        str +=  ' (' + item.tracking_number + ')'
                    }
                }
                return str
            }
        },

     
        {
            small:true,
            "value": "status",
            "text": "Status",
            "type": "list",
            list:["Created", "Confirmed", "Shipped", "Delivered"],
            "table": {
                "sortable": true,
                "filter": true
            },
            "validators": [
                "required"
            ]
        },


    ],
    "actions": [
        { "value": "update", "text": "Edit", "icon": "mdi-pencil", "color": "primary" },
    ]
}